import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  selectVariants: () => __(translations.saveProductAs.selectVariants, 'Please, select all variants that you wish to copy'),
  title: () => __(translations.saveProductAs.alertTitle, 'Save product as'),
  selectAll: () => __(translations.saveProductAs.selectAll, 'Select all'),
};
